import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 6l-8 4l8 4l8 -4l-8 -4","key":"svg-0"}],["path",{"d":"M4 14l8 4l8 -4","key":"svg-1"}]]

/**
 * IconStack
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3RhY2siCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDZsLTggNGw4IDRsOCAtNGwtOCAtNCIgLz4KICA8cGF0aCBkPSJNNCAxNGw4IDRsOCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/stack
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconStack = createReactComponent('outline', 'stack', 'Stack', __iconNode);

export default IconStack;